export function getScrollbarThemeOverrides(
	thickness: string | number = 10,
	scrollbarPadding?: string | number,
) {
	const padding = (scrollbarPadding || scrollbarPadding === 0) ? parseInt(String(scrollbarPadding), 10) : undefined;
	const commonThumbStyles =
		(padding !== undefined)
			? {
				border: `${padding}px solid rgba(0, 0, 0, 0)`,
				backgroundClip: "padding-box",
				borderRadius: "9999px",
			}
			: {};

	return {
		"&::-webkit-scrollbar": {
			width: padding ? (parseInt(thickness as string, 10) + (padding * 2)) : thickness,
			height: padding ? (parseInt(thickness as string, 10) + (padding * 2)) : thickness,
		},
		"&::-webkit-scrollbar-track": {
			background: "transparent",
			boxShadow: "none",
		},
		"&::-webkit-scrollbar-thumb": {
			background: "#E8E8E8",
			borderRadius: thickness,
			outline: "none",
			...commonThumbStyles,
		},
		"&::-webkit-scrollbar-thumb:hover": {
			background: "#BABABA",
			...commonThumbStyles,
		},
		"&::-webkit-scrollbar-thumb:active": {
			background: "#7C7C7C",
			...commonThumbStyles,
		},
		"&::webkit-scrollbar-track-piece:start": {
			background: "transparent",
		},
		"&::webkit-scrollbar-track-piece:end": {
			background: "transparent",
		},
	};
}

const scrollbarThemeOverrides = getScrollbarThemeOverrides();
export default scrollbarThemeOverrides;
